<template>
<span>
  {{ title }}  
</span>  
</template>
<script>
import Attribute from '@/store/models/Attribute'
export default {
  props: {
    attribute: {
      type: Object,
      default: () => (new Attribute)
    }
  },

  computed: {
    title() {
      return this.isProduct 
        ? `${this.attribute.software_version.product.name} - ${this.attribute.software_version.code}`
        : this.attribute.type.title
    },
    isProduct() {
      return this.attribute.software_version !== null
    }
  }
}
</script>